import { formatCurrencyForDisplay } from '@utils'
import cn from 'classnames'
import { useCurrencies } from 'mmfintech-backend-api'
import { formatFloat } from 'mmfintech-commons'

import styles from './AmountDisplay.module.scss'

type AmountDisplayProps = {
  amount: number
  currency: string
  'data-test'?: string
  className?: string
  amountClassName?: string
  currencyClassName?: string
  simple?: boolean
}

const useAmountDisplayHelper = (amount: number, currency: string) => {
  const { getCurrencyPrecision } = useCurrencies()

  const decimals = getCurrencyPrecision(currency)
  const formattedAmount = formatFloat(amount, decimals, decimals > 2 ? 2 : decimals)
  const formattedCurrency = formatCurrencyForDisplay(currency)

  return {
    formattedAmount,
    formattedCurrency
  }
}

export const AmountDisplay = (props: AmountDisplayProps) => {
  const { amount, currency, 'data-test': dataTest, className, amountClassName, currencyClassName, simple } = props

  const { formattedAmount, formattedCurrency } = useAmountDisplayHelper(amount, currency)

  return simple ? (
    `${formattedAmount} ${formattedCurrency}`
  ) : (
    <span className={cn(styles['amount-display'], className)}>
      <span className={amountClassName ?? 'amount'} data-test={dataTest ? `${dataTest}-amount` : undefined}>
        {formattedAmount}
      </span>
      <span className={currencyClassName ?? 'currency'} data-test={dataTest ? `${dataTest}-currency` : undefined}>
        {formattedCurrency}
      </span>
    </span>
  )
}

export const useAmountDisplay = (amount: number, currency: string) => {
  const { formattedAmount, formattedCurrency } = useAmountDisplayHelper(amount, currency)
  return `${formattedAmount} ${formattedCurrency}`
}
